import React, { memo } from 'react';
import logoGovCo from '../img/gov-co.png';

const GovBar = () => {
  return (
    <div className="w-full bg-cobalt">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-14 flex items-center">
        <a
          href="https://www.gov.co/home/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ir al Portal Único del Estado Colombiano GOV.CO (abre en una nueva pestaña)"
          className="inline-flex items-center min-h-[44px] min-w-[44px] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-cobalt rounded"
        >
          <img
            src={logoGovCo}
            alt="Logo Gobierno de Colombia GOV.CO"
            className="h-6 w-auto object-contain"
          />
        </a>
      </div>
    </div>
  );
};

export default memo(GovBar);
